export enum QuestionnaireEventsEnum {
  QUESTIONNAIRE_SUBMITTED = "questionnaire:submitted"
}
